import { en } from './locales/en';
import { ptBR } from './locales/pt-BR';

export const LANGUAGE_STORAGE_KEY = 'delay.language';

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en'] as const;

export type Language = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: Language = 'pt-BR';

export type LoginTranslations = {
  title: string;
  email: string;
  password: string;
  thanks: string;
  submit: string;
  submitting: string;
  requiredFields: string;
  invalidCredentials: string;
  planInactive: string;
  forgotPassword: string;
  forgotPasswordTitle: string;
  forgotPasswordDescription: string;
  sendResetCode: string;
  sendingResetCode: string;
  backToLogin: string;
  resetCodeSent: string;
  resetPasswordTitle: string;
  resetPasswordDescription: string;
  resetCode: string;
  newPassword: string;
  confirmPassword: string;
  resetPassword: string;
  resettingPassword: string;
  resetPasswordSuccessTitle: string;
  resetPasswordSuccessDescription: string;
  invalidEmail: string;
  resetCodeRequired: string;
  invalidResetCode: string;
  passwordRequired: string;
  passwordMinLength: string;
  passwordsDoNotMatch: string;
  passwordResetRequestError: string;
  passwordResetError: string;
  languageLabel: string;
  portugueseLanguage: string;
  englishLanguage: string;
};

export type TranslationTree = {
  login: LoginTranslations;
  common: Record<string, string>;
  menu: Record<string, string>;
  accessibility: Record<string, string>;
  register: Record<string, string>;
  instruction: Record<string, string>;
  resetPassword: Record<string, string>;
  reports: Record<string, string>;
  profile: Record<string, string>;
  admin: Record<string, string>;
};

export const translations: Record<Language, TranslationTree> = {
  'pt-BR': ptBR,
  en,
};

export type TranslationNamespace = keyof TranslationTree;
export type TranslationKey<TNamespace extends TranslationNamespace> =
  keyof TranslationTree[TNamespace];
